/* eslint-disable */
/* THIS FILE HAS BEEN GENERATED DO NOT EDIT IT DIRECTLY */
import * as Types from '../../../../graphql/__generated__/types';

import { gql } from '@apollo/client';
import { OrganizationSubscriptionsFragmentDoc } from '../../../../components/organization/__generated__/AppsOverviewTable.graphql';
import * as ApolloReactCommon from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
const defaultOptions = {} as const;
export type AppsPageQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type AppsPageQuery = { __typename: 'Query', organization: { __typename: 'Organization', id: string, appSubscriptions: Array<{ __typename: 'OrganizationAppSubscription', id: string, name: string, iconUrl?: string | null, updatedAt: any, usage: { __typename: 'SubscriptionUsage', current: number, max?: number | null } }> } };


export const AppsPageDocument = gql`
    query AppsPage {
  organization {
    id
    appSubscriptions {
      ...OrganizationSubscriptions
    }
  }
}
    ${OrganizationSubscriptionsFragmentDoc}`;

/**
 * __useAppsPageQuery__
 *
 * To run a query within a React component, call `useAppsPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useAppsPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAppsPageQuery({
 *   variables: {
 *   },
 * });
 */
export function useAppsPageQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AppsPageQuery, AppsPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AppsPageQuery, AppsPageQueryVariables>(AppsPageDocument, options);
      }
export function useAppsPageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AppsPageQuery, AppsPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AppsPageQuery, AppsPageQueryVariables>(AppsPageDocument, options);
        }
export type AppsPageQueryHookResult = ReturnType<typeof useAppsPageQuery>;
export type AppsPageLazyQueryHookResult = ReturnType<typeof useAppsPageLazyQuery>;
export type AppsPageQueryResult = ApolloReactCommon.QueryResult<AppsPageQuery, AppsPageQueryVariables>;